import { Libraries, Loader } from '@googlemaps/js-api-loader';

class GoogleMapsApiService {
  public apiKey = 'AIzaSyAZCdmt3j8Fk_80Y-bJ0rU6Q2-VxbcpAAU';
  public apiVersion = '3.59';
  public libraries: Libraries = ['marker', 'places'];

  private static map: Promise<any>;

  load() {
    if (!GoogleMapsApiService.map) {
      GoogleMapsApiService.map = this.requestMap();
    }
    return GoogleMapsApiService.map;
  }

  private async requestMap() {
    const loader = new Loader({
      apiKey: this.apiKey,
      version: this.apiVersion,
      libraries: this.libraries,
    });

    return loader.importLibrary('maps');
  }
}

export const GoogleMapsApi = new GoogleMapsApiService();
